export default __webpack_public_path__ + "static/media/DefaultNewsletterThumbnail.2d9662f0.jpg";